import React from 'react';

import { Box, Heading, Logo, tokens, Body } from '@iclinic/design-system';
import { SignupFormContainer, SignupFormLogo } from './Form.styles';
import SingleSignupForm from './Form';

const SingleSignupFormContainer = () => {
  return (
    <SignupFormContainer>
      <Box display="flex" justifyContent="center" mb={tokens.spacing.lg}>
        <SignupFormLogo color={Logo.Colors.Blue} width={110} showName />
      </Box>
      <Box mb={tokens.spacing.base}>
        <Heading variant="sm">Teste gratuitamente</Heading>
      </Box>
      <Box mb={tokens.spacing.sm}>
        <Body variant="xs">Não pedimos seu cartão de crédito</Body>
      </Box>
      <SingleSignupForm />
    </SignupFormContainer>
  );
};

export default SingleSignupFormContainer;
